import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="space-y-2">
      <h1 className="text-xl font-semibold">Page not found</h1>
      <Link className="text-emerald-700 underline" to="/">
        Back to home
      </Link>
    </div>
  );
}
